import { defaultListParams } from "src/features/common/constants/defaultListParams";
import { cleanParams } from "src/features/common/helpers/cleanParams";
import { FilterFields } from "../types/FilterFields";
import { DefaultListParams } from "src/features/common/types/DefaultListParams";
import { useChains } from "src/components/FetchConfig";
import { separateBatchStrings } from "src/utils/helper";

const useGetListParams = () => {
  const { selectChainByPieces } = useChains();
  const getListParams = (fields: FilterFields) => {
    const {
      creationTime,
      lastModifiedTime,
      batchId,
      chainName,
      assetName,
      spenderAddress,
      statuses,
    } = fields;

    const { start: createdDateFrom, end: createdDateTo } = creationTime;

    const { start: lastModifiedDateFrom, end: lastModifiedDateTo } =
      lastModifiedTime;

    const { chain_id, chain_type } = selectChainByPieces({
      chain_name: chainName,
    });

    const params: DefaultListParams = {
      ...defaultListParams,
      createdDateFrom,
      createdDateTo,
      lastModifiedDateFrom,
      lastModifiedDateTo,
      chain_id,
      chain_type,
      batchIds: separateBatchStrings(batchId),
      spenderAddress,
      fromAssetNames: assetName ? [assetName] : [],
      operationStatuses: statuses,
    };

    return cleanParams(params);
  };

  return {
    getListParams,
  };
};

export default useGetListParams;
